import React, { useState, useMemo, createContext, } from "react";

// 1️⃣ Create Context
const HomeContext = createContext(null);

// 2️⃣ Provider Component
export const HomeProvider = ({ children }) => {
  const [profile, setProfile] = useState(null);
  const [homeloading,setHomeloading] =useState(false)
  const [prorefetch,setProrefetch] = useState(false)
  const [kycdoc,setKycdoc] = useState([])
  const [homedoc,setHomedoc] = useState({})
  const [sitedoc,setSitedoc] = useState({})
   const [siteloading,setSiteloading] =useState(false)
  const [faqdoc,setFaqdoc] = useState([])

//   // 3️⃣ Memoized value to prevent unnecessary re-renders
//   const contextValue = useMemo(() => {
//     return { 
//       profile, 
//       setProfile,
//       setProrefetch,
//       prorefetch,
//       setKycdoc,
//       kycdoc,
//       setHomedoc,
//       homedoc,
//       faqdoc,setFaqdoc,
//       homeloading,setHomeloading,
//       sitedoc,setSitedoc,
//       siteloading,setSiteloading
//     };
// }, [profile, prorefetch,kycdoc,faqdoc,homeloading,sitedoc,siteloading]);


const contextValue = useMemo(() => {
  return { 
    profile, 
    setProfile,
    setProrefetch,
    prorefetch,
    setKycdoc,
    kycdoc,
    setHomedoc,
    homedoc,
    faqdoc,
    setFaqdoc,
    homeloading,
    setHomeloading,
    sitedoc,
    setSitedoc,
    siteloading,
    setSiteloading
  };
}, [
  profile,
  prorefetch,
  kycdoc,
  homedoc,   // ✅ important
  faqdoc,
  homeloading,
  sitedoc,
  siteloading
]);


  return (
    <HomeContext.Provider value={contextValue}>
      {children}
    </HomeContext.Provider>
  );
};

export default HomeContext;

